import CarDetail from '../containers/CarDetail';
import { ListCarDTO } from '../modules/generated/api';

import ActionCarDetailPrint from './ActionCarDetailPrint';
import ActionDetailLink from './ActionDetailLink';
import DetailDialog from './DetailDialog';

type CarDetailDialogProps = {
  car?: ListCarDTO;
  index?: number;
  maxCars: number;
  moveToNext?: () => void;
  moveToPrev?: () => void;
  onClose: () => void;
  onEdit?: () => Promise<unknown>;
};

const CarDetailDialog = ({ car, index, maxCars, moveToNext, moveToPrev, onClose, onEdit }: CarDetailDialogProps) => {
  const { carId, source } = car || {};

  return (
    <DetailDialog
      open={!!car}
      index={index}
      maxItems={maxCars}
      moveToNext={moveToNext}
      moveToPrev={moveToPrev}
      onClose={onClose}
      actionsTopRight={
        <>
          <ActionDetailLink
            key="detail-link"
            href={source && carId ? `/cars/${source}/${carId}` : ''}
            disabled={!source || !carId}
            tooltipPosition="left"
          />
          <ActionCarDetailPrint key="detail-print" toolTipPosition="bottom" />
        </>
      }
    >
      {source && carId && (
        <CarDetail
          source={source}
          carId={carId}
          onRefresh={onEdit}
          valuationCountry={car?.potential?.country}
          isDetailPage
        />
      )}
    </DetailDialog>
  );
};

export default CarDetailDialog;
